import { render, staticRenderFns } from "./RelocateGoodsPopup.vue?vue&type=template&id=a0972cea&scoped=true"
import script from "./RelocateGoodsPopup.vue?vue&type=script&lang=js"
export * from "./RelocateGoodsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0972cea",
  null
  
)

export default component.exports